import { Button as AntButton, Card, Divider, Flex, Spin, Table, Typography } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { ReactComponent as Back } from '../../../assets/arrow.svg';
import {
  ChangeOfCourseAuditLog,
  useGetChangeOfCourseAuditLogQuery,
} from '../../../hooks/api/studentInfo/useGetChangeOfCourseAuditLogQuery';
import { routes } from '../../../routes';
import { formatFullDate } from '../../../utils/formatDate';
import styles from '../styles.module.scss';

const { Text } = Typography;

const CourseChangeAudit = () => {
  const { id: applicantId } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const applicant = location.state?.applicant as User | undefined;
  const {
    changeOfCourseAuditLogData,
    isChangeOfCourseAuditLogLoading,
    isChangeOfCourseAuditLogError,
    changeOfCourseAuditLogErrorMessage,
  } = useGetChangeOfCourseAuditLogQuery(applicantId);

  const columns: ColumnsType<ChangeOfCourseAuditLog> = [
    {
      key: 'sn',
      title: 'S/N',
      render: (_text, _record, index) => index + 1,
    },
    {
      key: 'changedBy',
      title: 'Changed By',
      dataIndex: 'changedBy',
    },
    {
      key: 'previousProgramId',
      title: 'Previous Program',
      dataIndex: 'previousProgramId',
      render: (value) => value ?? 'N/A',
    },
    {
      key: 'newProgramId',
      title: 'New Program',
      dataIndex: 'newProgramId',
      render: (value) => value ?? 'N/A',
    },
    {
      key: 'previousConcentrationId',
      title: 'Previous Concentration',
      dataIndex: 'previousConcentrationId',
      render: (value) => value ?? 'N/A',
    },
    {
      key: 'newConcentrationId',
      title: 'New Concentration',
      dataIndex: 'newConcentrationId',
      render: (value) => value ?? 'N/A',
    },
    {
      key: 'previousProgramTypeId',
      title: 'Previous Program Type',
      dataIndex: 'previousProgramTypeId',
      render: (value) => value ?? 'N/A',
    },
    {
      key: 'newProgramTypeId',
      title: 'New Program Type',
      dataIndex: 'newProgramTypeId',
      render: (value) => value ?? 'N/A',
    },
    {
      key: 'reason',
      title: 'Reason',
      dataIndex: 'reason',
    },
    {
      key: 'changedAt',
      title: 'Changed At',
      dataIndex: 'changedAt',
      render: (value) => formatFullDate(value),
    },
  ];

  return (
    <div className={styles.page}>
      <Flex align="center" gap="8px" className={styles.headerBar}>
        <AntButton type="text" onClick={() => navigate(routes.userMgt.users)}>
          <Back />
        </AntButton>
        <h3>Course Change Audit</h3>
      </Flex>
      <Divider style={{ margin: '12px 0 20px' }} />

      <Card
        className={styles.sectionCard}
        title={applicant ? `${applicant.firstName} ${applicant.lastName}` : 'Audit Logs'}
        styles={{ body: { padding: 16 } }}
      >
        {isChangeOfCourseAuditLogLoading ? (
          <Spin />
        ) : isChangeOfCourseAuditLogError ? (
          <Text type="danger">{changeOfCourseAuditLogErrorMessage}</Text>
        ) : (
          <Table
            dataSource={changeOfCourseAuditLogData}
            columns={columns}
            rowKey={(record) => record.id}
            pagination={false}
            scroll={{ x: true }}
          />
        )}
      </Card>
    </div>
  );
};

export default CourseChangeAudit;
